import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'pl_PL',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '3ac8b25e-f1d3-4351-90e8-5900a2377c91',
  ''
);
